//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

import {
	ALERTS_WIZARD_ALERT_OPEN,
	ALERTS_WIZARD_ALERT_SAVE,
	ALERTS_WIZARD_ALERT_TYPES_SUPPORTED,
	ALERTS_WIZARD_GET_ALERT
} from 'Redux/actionTypes';

//actions 
import {
	alertsWizardOpenResult,
	alertsWizardSaveResult,
	alertsWizardAlertTypesSupported,
	alertsWizardAlertTypesSupportedResult,
	alertWizardAlertByIdResult,
	alertWizardAlertById
} from 'Redux/actions';

const route = 'modules/alerts/components/wizardAlert/redux/saga'

/* FUNCTIONS ASYNC */
function* alertsWizardOpenRequest() {
	yield takeEvery(ALERTS_WIZARD_ALERT_OPEN, function* ({ payload }) {
		try {
			if(payload?.id){
				yield put(alertWizardAlertById({ code: payload?.type }))	
			}else{
				yield put(alertsWizardAlertTypesSupported())
			}
			yield put(alertsWizardOpenResult({ data: null }))
			//alertWizardAlertById
		} catch (exc) {
			ExceptionManager(exc, route, 'alertsWizardOpenRequest');
			yield put(alertsWizardOpenResult({ error: exc.error }));
		}
	});
}


function* alertWizardGetSupportedRequest() {
	yield takeEvery(ALERTS_WIZARD_ALERT_SAVE, function* ({ payload }) {
		try {
			const {
				id,
				name,
				type,
				config,
				severity,
				summary,
				triggers,
				assignedTo,
				schedule,
				subscribers,
			} = payload;

			let data
			if (id) {
				//update
				data = yield call(
					clientMutation,
					`mutation updateSystemAlert ($id: String!, $name: String, $type: enumAlertType, $config: AWSJSON, $severity: Severity!, $summary: String, $triggers: [SystemAlertTriggerInput], $assignedTo: [SystemAlertAssignmentInput], $schedule: SystemAlertScheduleInput, $subscribers: [AlertSubscriberInput]) {
						updateSystemAlert (id: $id, name: $name, type: $type, config: $config, severity: $severity, summary: $summary, triggers: $triggers, assignedTo: $assignedTo, schedule: $schedule, subscribers: $subscribers) {
							id
						}
					}`,
					{
						id, name, type, config, severity, summary, triggers, assignedTo, schedule, subscribers
					},
					endpoints.GRAPHQL_GENERAL,
				);
			}
			else {
				//create
				data = yield call(
					clientMutation,
					`mutation createSystemAlert ($name: String!, $type: enumAlertType!, $config: AWSJSON, $severity: Severity!, $summary: String, $triggers: [SystemAlertTriggerInput], $assignedTo: [SystemAlertAssignmentInput], $schedule: SystemAlertScheduleInput, $subscribers: [AlertSubscriberInput]) {
						createSystemAlert (name: $name, type: $type, config: $config, severity: $severity, summary: $summary, triggers: $triggers, assignedTo: $assignedTo, schedule: $schedule, subscribers: $subscribers) {
							id
						}
					}`,
					{
						name, type, config, severity, summary, triggers, assignedTo, schedule, subscribers
					},
					endpoints.GRAPHQL_GENERAL,
				);
			}

			if (data) {
				yield put(alertsWizardSaveResult({ result: true, id: data.id }));
			} else {
				throw "Error Saving"
			}

		} catch (exc) {
			ExceptionManager(
				exc,
				'modules/alerts/components/newAlert/redux/saga',
				'searchAlertTypesSupported',
			);
			yield put(alertsWizardSaveResult({ result: false, error: exc }))
		}
	});
}

function* alertsWizardAlertTypesSupportedRequest() {
	yield takeEvery(ALERTS_WIZARD_ALERT_TYPES_SUPPORTED, function* () {
		try {

			let data = yield call(
				clientQuery,
				`query searchAlertTypes ($supportedOnly: Boolean) {
					result: searchAlertTypes(supportedOnly: $supportedOnly){
						id
						name
						code
						parentId
						unitVersionIds
					}
				}`,
				{
					supportedOnly: true
				},
				endpoints.GRAPHQL_GENERAL,
			);
			if (data.result) {
				yield put(alertsWizardAlertTypesSupportedResult(data.result));
			}

		} catch (exc) {
			ExceptionManager(exc, route, 'alertsWizardAlertTypesSupportedRequest');
			yield put(alertsWizardAlertTypesSupportedResult([]));
		}
	});
}

function* alertWizardAlertByIdRequest() {
	yield takeEvery(ALERTS_WIZARD_GET_ALERT, function* ({ payload }) {
		try {
			const { code } = payload
			let data = yield call(
				clientQuery,
				`query getAlertType ($code: String) {
					result: getAlertType (code: $code){
						id
						name
						code
						parentId
						unitVersionIds
					}
				}`,
				{
					code
				},
				endpoints.GRAPHQL_GENERAL,
			);
			if (data.result) {
				yield put(alertWizardAlertByIdResult(data.result))
			}

		} catch (exc) {
			ExceptionManager(exc, route, 'alertWizardAlertByIdRequest');
			yield put(alertWizardAlertByIdResult([]));
		}
	});
}

//MERGE SAGA
export default function* rootSaga() {
	yield all([fork(alertsWizardOpenRequest)]);
	yield all([fork(alertWizardGetSupportedRequest)]);
	yield all([fork(alertsWizardAlertTypesSupportedRequest)]);
	yield all([fork(alertWizardAlertByIdRequest)])
}
